import { useUser, SignInButton } from "@clerk/nextjs";
import { useState } from "react";
import { useRouter } from "next/router";
import { useFormContext } from "react-hook-form";
import Button from "@/components/ui/buttons/Button/Button";
import styles from "./SubmitButton.module.scss";
import { getCookie } from "utils";

export default function SubmitButton({}) {
  const [isLoading, setIsLoading] = useState(false);

  const {
    getValues,
    onSubmit,
    reset,
    formState,
    trigger,
    setError,
    clearErrors,
  } = useFormContext();
  const { errors } = formState;

  const router = useRouter();
  const { isSignedIn, user } = useUser();

  const handleSubmit = async (event) => {
    event.preventDefault();
    clearErrors();
    await trigger();

    setIsLoading(true);
    try {
      // if (Object?.keys(errors)?.length) {
      //   setIsLoading(false);
      //   return;
      // }

      const formValues = getValues();

      const tempUserId = getCookie("temp_user_id") ?? null;

      const guideRequestBody = {
        location: formValues?.location,
        tripData: {
          dates: formValues?.trip_length,
        },
        preferences: {
          travel_style: formValues?.travel_style,
          budget: formValues?.budget,
          accommodation: formValues?.accommodation,
          activities: formValues?.activities,
        },
        author: {
          tempUserId,
          id: user?.id,
        },
      };

      // onSubmit({ responseData: {} });

      const guideResponse = await fetch("/api/travel-guide/generate/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(guideRequestBody),
      });

      if (!guideResponse.ok) {
        const errorData = await guideResponse.json();
        console.error(errorData);
        setIsLoading(false);
        setError("submission", {
          message: errorData?.message,
          error: errorData,
        });

        throw new Error(JSON.stringify(errorData));
      }

      const { data: guideData } = await guideResponse.json();

      await onSubmit({ responseData: guideData });

      router.replace(
        {
          pathname: router.pathname,
          query: {},
        },
        undefined,
        {
          shallow: true,
          scroll: false,
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`${styles.buttonWrapper}`}>
      {!isSignedIn && (
        <SignInButton>
          <Button classes={["sign-in-button"]}>Sign In</Button>
        </SignInButton>
      )}
      {isSignedIn && (
        <Button
          type="submit"
          label="Submit"
          onClick={handleSubmit}
          loading={isLoading}
          disabled={
            !["SERVER_ERROR", "API_ERROR"].includes(
              errors?.submission?.error?.type
            ) &&
            !!Object.keys(errors).length &&
            !Object.keys(errors).includes("root")
          }
          classes={["travel-guide-submit-button"]}
        >
          Generate Travel Guide
        </Button>
      )}
    </div>
  );
}
